import React from 'react';

import './CenterLayout.scss';

function CenterLayout({children}) {
  return <div styleName="layout">{children}</div>;
}

export default React.memo(CenterLayout);